import $ from 'jquery';
// import tippy from 'tippy.js';

/* global tippy, x5script */

class Tooltip {
  constructor() {
    this.tooltip = $('.js-tooltip');
    this.glossaryContent = $('.js-glossary-content');
    this.makeTooltips();
    this.glossary();
  }

  makeTooltips() {
    if (!this.tooltip.length) {
      return;
    }

    $.each(this.tooltip, (i, el) => {
      const tooltip = $(el);
      const button = tooltip.find('button');
      const text = tooltip.find('.js-tooltip-content');

      tippy(button[0], {
        content: text.html(),
        theme: 'material',
        allowHTML: true,
      });
    });
  }

  glossary() {
    if (!this.glossaryContent.length) {
      return;
    }

    const { glossaryData } = x5script;
    const blocks = $(
      '.is-core-list-block, .is-core-paragraph-block, .is-core-heading-block',
    );
    const keywordsFound = [];
    const templates = [];

    if (glossaryData && blocks.length) {
      $.each(blocks, (i, el) => {
        Object.entries(glossaryData).forEach(([postid, data]) => {
          const find = `([^"-])(${data.keyword})([^"-])`;
          const replace = `$1<span data-template="glossary-${postid}-${i}" class="js-glossary c-glossary">$2</span>$3`;
          const match = $(el)
            .html()
            .match(find);

          if (match !== null) {
            if (!keywordsFound.includes(match[2])) {
              $(el).html(
                $(el)
                  .html()
                  .replace(new RegExp(find, 'igm'), replace),
              );

              keywordsFound.push(match[2]);
              const innerContents = [];

              const glossaries = $(el).find('.js-glossary');

              if (glossaries) {
                glossaries.each((index, gloss) => {
                  const innerText = $(gloss).text();
                  if (!innerContents.includes(innerText)) {
                    innerContents.push(innerText);
                  } else {
                    $(gloss)
                      .contents()
                      .unwrap();
                  }
                });
              }

              const glossary = $(el)
                .find('.js-glossary')
                .first();

              if (glossary.length) {
                templates.push(
                  `<div class="c-glossary__template js-glossary-template" id="glossary-${postid}-${i}">${
                    data.content
                  }</div>`,
                );
              }
            }
          }
        });
      });
    }

    if (templates.length) {
      this.glossaryContent.append(
        $('<div></div>', {
          class: 'c-glossary__templates',
          html: templates.join(''),
        }),
      );
      this.glossaryInit();
    }
  }

  glossaryInit() {
    const glossaries = this.glossaryContent.find('.js-glossary');

    if (!glossaries.length) {
      return;
    }

    $.each(glossaries, (i, el) => {
      tippy(el, {
        content(element) {
          const id = $(element).attr('data-template');
          const text = $('body').find(`.js-glossary-template#${id}`);

          if (text.length) {
            return text.html();
          }

          return '';
        },
        theme: 'material',
        allowHTML: true,
      });
    });
  }
}

export default new Tooltip();



// WEBPACK FOOTER //
// ./src/scripts/modules/tooltip.js